import React from 'react';
import { StatusBadge } from '../../../components/StatusBadge/StatusBadge';
import { formatCurrency, formatCycle } from '../utils';

const META_ROWS = [
  {
    key: 'displayClient',
    label: 'Visível ao cliente',
    format: (plan) => (plan.displayClient ? 'Sim' : 'Não'),
  },
];

export function PlanCard({ plan, selected, onToggleSelected }) {
  return (
    <div className="card card-custom h-100">
      <div className="card-body d-flex flex-column">
        <div className="d-flex align-items-start justify-content-between mb-4">
          <div
            className="d-flex align-items-center flex-wrap"
            style={{ gap: 8 }}
          >
            <h4 className="mb-0 font-weight-bolder text-dark">{plan.name}</h4>
            <span className="badge badge-light-primary">
              {formatCycle(plan.cycleDays)}
            </span>
          </div>
          <StatusBadge
            label={plan.active ? 'Ativo' : 'Inativo'}
            variant={plan.active ? 'success' : 'danger'}
          />
        </div>

        <label
          className="d-flex align-items-center mb-4 text-muted"
          style={{ gap: 8, minHeight: 24, cursor: 'pointer' }}
        >
          <input
            type="checkbox"
            checked={selected}
            onChange={() => onToggleSelected(plan.id)}
          />
          Incluir no comparativo
        </label>

        <div className="mb-6">
          <span className="font-size-h2 font-weight-bolder text-dark">
            {formatCurrency(plan.amount)}
          </span>
          <span className="text-muted">
            {' '}
            / {formatCycle(plan.cycleDays).toLowerCase()}
          </span>
        </div>

        <dl className="mb-0 mt-auto">
          {META_ROWS.map(({ key, label, format }) => (
            <div
              key={key}
              className="d-flex justify-content-between py-2 border-top"
            >
              <dt className="text-muted font-weight-normal mb-0">{label}</dt>
              <dd className="mb-0 text-dark text-right">{format(plan)}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
